<template>
  <Teleport to="body">
    <Transition name="fade">
      <div v-if="active" class="pmg-loading-overlay">
        <div class="pmg-loading-content">
          <div class="pmg-spinner"></div>
          <p class="pmg-loading-text">{{ message }}</p>
        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<script>
export default {
  name: 'LoadingOverlay',
  // Definimos as props no estilo tradicional (Options API)
  props: {
    active: {
      type: Boolean,
      default: false
    },
    message: {
      type: String,
      default: 'Processando...'
    }
  }
}
</script>

<style scoped>
.pmg-loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(15, 23, 42, 0.7); /* Azul marinho escuro */
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.pmg-spinner {
  width: 60px;
  height: 60px;
  border: 5px solid rgba(59, 130, 246, 0.1);
  border-left-color: #3b82f6; /* Aquele azul neon da foto */
  border-radius: 50%;
  animation: spin 1s linear infinite;
  filter: drop-shadow(0 0 10px rgba(59, 130, 246, 0.5));
}

.pmg-loading-text {
  margin-top: 20px;
  color: #ffffff;
  font-weight: 600;
  font-size: 1.2rem;
  letter-spacing: 0.5px;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s ease;
}
.fade-enter-from, .fade-leave-to {
  opacity: 0;
}
</style>